import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type RemoveProgramResponseType = ResponseType<null>;

function useRemoveProgramMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<RemoveProgramResponseType>["response"],
    AxiosResponseAndError<RemoveProgramResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<RemoveProgramResponseType>(
        `${requestURLs.project}/program/${data}`
      ),
  });

  return mutation;
}

export default useRemoveProgramMutation;
